// modules/inicio/api/listasAPI.js
// Catálogos de solo lectura (territorios, comunidades, AATI, etnias,
// EPS/EAPB), consumidos por los formularios de captura. Va en inicio/ (no
// en un módulo de estrategia) porque cualquier estrategia futura los va a
// necesitar, no solo RBC.
import axiosClient from "./axiosClient";

export const getTerritorios = () => axiosClient.get("/listas/territorios");
export const getComunidades = (territorio) => axiosClient.get("/listas/comunidades", { params: { territorio } });
export const getAatis = (territorio) => axiosClient.get("/listas/aatis", { params: { territorio } });
export const getEtnias = () => axiosClient.get("/listas/etnias");
export const getEapbs = () => axiosClient.get("/listas/eapbs");
